import React from 'react'
import MaterialSymbol from '../material-symbol'

const CloudUpload = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="cloud_upload" {...props} />
))

CloudUpload.displayName = 'CloudUpload'

export default CloudUpload
